module.exports = __webpack_public_path__ + "img/restaurant-2.cd8cec0d.jpg";